import OptimizedImage from "@/components/OptimizedImage";
import React from "react";
import { User } from "lucide-react";
import { useArtistUsp } from "@/api/hooks/useArtistUsp";
import { useArtistDisplayName, useArtistProfilePic } from "@/api/hooks/useArtistDisplayName";
import { SparkleMaskedName } from "@/components/ui/SparkleMaskedName";
import MaskProfessionalNameInText from "../../utils/MaskProfessionalNameInText";

const ArtistFreeHero = () => {
  const { uspText, hasUsp } = useArtistUsp();
  const displayName = useArtistDisplayName();
  const profilePic = useArtistProfilePic();

  return (
    <div className="flex flex-col justify-center md:flex-row md:justify-around items-center h-[80vh] md:px-5 lg:px-0 w-screen">
      <div className="max-w-[27rem] w-full max-sm:w-[95%] h-[600px] relative overflow-hidden rounded-xl bg-[#2C2C2E] flex items-center justify-center">
        {profilePic ? (
          <OptimizedImage
            src={profilePic}
            alt={displayName}
            className="w-full h-full object-cover object-top"
            fill={true}
          />
        ) : (
          <User className="h-[40%] w-[40%] text-[#8E8E93] opacity-50" />
        )}
      </div>

      {/* Wrapping text inside a div with scale fix */}
      <div className="flex flex-col justify-start gap-[10px]  md:max-w-[470px] lg:max-w-[570px] h-auto text-fixed p-4">
        {/* <p className='text-[14px] sm:text-[20px] font-normal'>THIS IS ME</p> */}
        <p className="text-[30px] sm:text-[60px] font-semibold">
          <SparkleMaskedName name={displayName} />
        </p>
        <p
          className={`text-[14px] sm:text-[20px] font-light ${!hasUsp ? "opacity-80 italic" : ""}`}
        >
          <MaskProfessionalNameInText value={uspText} />
        </p>
        <p className="text-[14px] sm:text-[16px] max-w-56 w-full p-[0.7rem] font-light mt-5 rounded-2xl bg-gradient-to-r from-[#F16633CC] to-[#FD2D7DCC] text-center">
          SEE PRICE & BOOK
        </p>
      </div>
    </div>
  );
};

export default ArtistFreeHero;
